import React, { memo } from 'react'
import tw from 'twin.macro'
import { FormikDatePicker } from 'src/components/shared/form/formik/FormikDatePicker'
import { FormikSelect } from 'src/components/shared/form/formik/FormikSelect'
import { FormikTextField } from 'src/components/shared/form/formik/FormikTextField'
import { PERSON_IDENTIFICATION_TYPE_OPTIONS } from 'src/constants/payments-ops/bankOnboarding'
import type { BankOnboardingFormValues } from 'src/interfaces/bankOnboarding'
import { OnboardingAddressFields } from '../OnboardingAddressFields'

const CONTROL_PERSON_ADDRESS_FIELDS = {
  addressLine1: 'controlPersonAddressLine1',
  addressLine2: 'controlPersonAddressLine2',
  city: 'controlPersonCity',
  state: 'controlPersonState',
  zipCode: 'controlPersonZipCode',
  country: 'controlPersonCountry',
}

const ControlPersonStepComponent = () => {
  return (
    <div css={tw`flex flex-col gap-4`}>
      <div css={tw`grid grid-cols-2 gap-4`}>
        <div css={tw`col-span-2`}>
          <FormikTextField<BankOnboardingFormValues>
            name="controlPersonTitle"
            label="Title *"
            placeholder="e.g. CEO"
          />
        </div>
        <FormikTextField<BankOnboardingFormValues>
          name="controlPersonFirstName"
          label="First name *"
          placeholder="First name"
        />
        <FormikTextField<BankOnboardingFormValues>
          name="controlPersonLastName"
          label="Last name *"
          placeholder="Last name"
        />
        <FormikSelect<BankOnboardingFormValues>
          name="controlPersonIdentificationType"
          label="ID type *"
          options={PERSON_IDENTIFICATION_TYPE_OPTIONS}
          placeholder="SSN or ITIN"
        />
        <FormikTextField<BankOnboardingFormValues>
          name="controlPersonIdentificationNumber"
          label="ID number *"
          placeholder="9 digits"
        />
        <FormikTextField<BankOnboardingFormValues>
          name="controlPersonIssuingCountry"
          label="ID issuing country *"
          placeholder="US"
          inputProps={{ maxLength: 2 }}
        />
        <FormikDatePicker<BankOnboardingFormValues>
          name="controlPersonDateOfBirth"
          label="Date of birth *"
          fullWidth
          validateOnPick
        />
        <FormikTextField<BankOnboardingFormValues>
          name="controlPersonPhoneNumber"
          label="Phone *"
          placeholder="10 digits"
          inputProps={{ inputMode: 'tel' }}
        />
      </div>
      <OnboardingAddressFields fieldNames={CONTROL_PERSON_ADDRESS_FIELDS} />
    </div>
  )
}

export const ControlPersonStep = memo(ControlPersonStepComponent)
